import type { PlatformDistribution } from '../../data/types';
import { formatLargeInt, formatPercent } from '../../lib/format';
import styles from './SourceMix.module.css';

interface SourceMixProps {
  distribution: PlatformDistribution;
}

export function SourceMix({ distribution }: SourceMixProps) {
  const total = distribution.twitter;
  if (total === 0) return null;

  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <h3 className={styles.title}>Where the evidence came from</h3>
        <span className={styles.totalNote}>n&nbsp;=&nbsp;{formatLargeInt(total)}</span>
      </header>

      <div className={styles.bar} role="img" aria-label="Twitter-only evidence">
        <div
          className={`${styles.segment} ${styles.twitter}`}
          style={{ ['--seg' as string]: '100%' }}
        />
      </div>

      <dl className={styles.list}>
        <div className={styles.cell}>
          <dt className={styles.label}>Twitter / X</dt>
          <dd className={styles.value}>
            {formatLargeInt(distribution.twitter)}
            <span className={styles.pct}>{formatPercent(1, 0)}</span>
          </dd>
        </div>
        <div className={styles.cell}>
          <dt className={styles.label}>Scope</dt>
          <dd className={styles.value}>
            Twitter only
            <span className={styles.pct}>family-level</span>
          </dd>
        </div>
      </dl>
    </section>
  );
}
